'use strict';

exports.__esModule = true;
var IntersectionObserver = exports.IntersectionObserver = typeof window !== 'undefined' && window.IntersectionObserver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-loadable-visibility/capacities.js
// module id = 169
// module chunks = 1